<template>
  <div class="loading-wrap vs-con-loading__container">
    <label class="block mb-2 vs-input--label">Тип заявки</label>
    <ul class="flex mb-3">
      <li class="mr-5">
        <vs-radio
          v-validate="'required'"
          name="Поселок"
          v-model="newRequest.type"
          vs-value="request"
          >Заявка</vs-radio
        >
      </li>
      <li>
        <vs-radio
          v-validate="'required'"
          name="Поселок"
          v-model="newRequest.type"
          vs-value="consierge"
          >Консьерж-сервис</vs-radio
        >
      </li>
    </ul>

    <template v-if="newRequest.type == 'request'">
      <vs-input
        class="w-full mb-4"
        label="Тема заявки"
        v-model="newRequest.theme"
      />

      <vs-input
        class="w-full mb-4"
        label="Сообщение заявки"
        v-model="newRequest.body"
      />
    </template>
    <template v-else>
      <label class="vs-input--label">Дата и время</label>
      <flat-pickr
        class="block w-full mb-4"
        :config="configdateTimePicker"
        v-model="newRequest.date_recommend"
      />

      <label class="vs-input--label">Категории</label>
      <ul class="mb-4">
        <li class="mb-1" v-for="(category, index) in categories" :key="index">
          <vs-checkbox v-model="newRequest.services" :vs-value="category.id">{{
            category.name
          }}</vs-checkbox>
        </li>
      </ul>
    </template>
    <vs-button @click="createNewRequest" :disabled="!validateForm" class="mr-5">
      Создать
    </vs-button>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian as RussianLocale } from "flatpickr/dist/l10n/ru.js";

import { DateTime } from "luxon";

export default {
  props: {
    user: { type: Object, required: true },
  },
  data() {
    return {
      newRequest: {
        type: "request",
        theme: "",
        body: "",
        //consierge
        services: [],
        date_recommend: "",
      },
      categories: [],

      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d.m.Y H:i",
        noCalendar: false,
        time_24hr: true,
        locale: RussianLocale,
        minDate: "today",
        minuteIncrement: 10,
      },
    };
  },
  watch: {
    "newRequest.type": function (val) {
      this.clearNewRequest(val);
      if (val == "consierge") {
        this.getAllConsiergeCategory();
      }
    },
  },
  components: {
    flatPickr,
  },
  computed: {
    validateForm() {
      if (this.newRequest.type == "request") {
        return (
          !this.errors.any() &&
          this.newRequest.theme !== "" &&
          this.newRequest.body !== ""
        );
      } else {
        return (
          !this.errors.any() &&
          this.newRequest.services.length > 0 &&
          this.newRequest.date_recommend !== ""
        );
      }
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    createNewRequest() {
      this.$load(async () => {
        if (this.newRequest.type == "request") {
          let payload = {
            theme: this.newRequest.theme,
            body: this.newRequest.body,
            user: this.user.id,
          };

          await this.$api.support
            .createTicket(payload)
            .then((response) => {
              this.clearNewRequest("request");
              this.notification("Успешно", "Заявка создана", "success");
            })
            .catch((error) => {
              this.notification(
                "Ошибка",
                "Не удалось создать заявку",
                "danger"
              );
            });
        } else {
          let payload = {
            full_name: this.user.full_name,
            phone: this.user.phone,
            address: this.user.homes[0].address,
            services: this.newRequest.services,
            date_recommend: DateTime.fromFormat(
              this.newRequest.date_recommend,
              "dd.MM.yyyy HH:mm"
            ).toISO({ includeOffset: false, suppressMilliseconds: true }),
            user: this.user.id,
          };

          await this.$api.services
            .createRequest(payload)
            .then((response) => {
              this.clearNewRequest("consierge");
              this.notification("Успешно", "Заявка создана", "success");
            })
            .catch((error) => {
              this.notification(
                "Ошибка",
                "Не удалось создать заявку",
                "danger"
              );
            });
        }
      });
    },
    getAllConsiergeCategory() {
      this.$vs.loading();
      this.categories = [];

      let payload = {
        limit: -1,
      };

      this.$load(async () => {
        let res = (
          await this.$api.services.getCategories(payload ? payload : "")
        ).data;

        res.results.forEach((category) => {
          let categoryData = {
            id: category.id,
            name: category.name,
          };

          this.categories.push(categoryData);
        });

        this.$vs.loading.close();
      });
    },
    clearNewRequest(type) {
      this.newRequest = {
        type: type,
        theme: "",
        body: "",
        services: [],
        date_recommend: "",
      };
    },
  },
};
</script>